module.exports = __webpack_public_path__ + "img/tree-01-h-trunk.1bd13ebb.png";